import { render, staticRenderFns } from "./ResourceSingleItem.vue?vue&type=template&id=005cc5ac&"
import script from "./ResourceSingleItem.vue?vue&type=script&lang=js&"
export * from "./ResourceSingleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports